import {name} from '../package.json';
import {defaultLogPath, createDefaultLogger} from '@libs/logger';

const logger = createDefaultLogger(name);

export {defaultLogPath};
export default logger;
